import React, { useState } from 'react';
import { C } from './SettingsTokens';
import { BackIcon, ChevronRight } from './SettingsIcons';

export function Badge({ label, color, bg }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '3px 9px', borderRadius: 9999,
      fontSize: 10, fontWeight: 700, letterSpacing: '0.07em',
      textTransform: 'uppercase', whiteSpace: 'nowrap',
      background: bg, color, fontFamily: C.font,
      flexShrink: 0,
    }}>{label}</span>
  );
}

export function SettingsRow({ icon, label, subtitle, badge, onPress, last = false }) {
  const [pressed, setPressed] = useState(false);
  return (
    <button
      onClick={onPress}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => { setPressed(false); }}
      onTouchCancel={() => setPressed(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 13,
        width: '100%', padding: '13px 16px', textAlign: 'left',
        background: pressed ? 'rgba(0,77,64,0.045)' : 'transparent',
        border: 'none',
        borderBottom: last ? 'none' : `1px solid ${C.border}`,
        cursor: 'pointer', fontFamily: C.font,
        WebkitTapHighlightColor: 'transparent',
        transition: 'background 0.12s',
        borderRadius: 0,
      }}
    >
      {icon && (
        <div style={{
          width: 36, height: 36, borderRadius: 10, flexShrink: 0,
          background: C.tealSoft,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: C.teal,
        }}>
          {icon}
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 500, color: C.text, letterSpacing: -0.1 }}>
          {label}
        </div>
        {subtitle && (
          <div style={{ fontSize: 12, color: C.textMuted, marginTop: 1 }}>
            {subtitle}
          </div>
        )}
      </div>
      {badge}
      <ChevronRight />
    </button>
  );
}

export function Section({ title, children }) {
  return (
    <div style={{ margin: '0 16px 20px' }}>
      <div style={{
        fontSize: 11, fontWeight: 700, letterSpacing: '0.12em',
        textTransform: 'uppercase', color: C.teal,
        padding: '0 4px 8px',
        display: 'flex', alignItems: 'center', gap: 8,
      }}>
        <div style={{ width: 14, height: 2, borderRadius: 2, background: C.amber, flexShrink: 0 }}/>
        {title}
      </div>
      <div style={{
        background: C.surfaceAlt,
        borderRadius: 16,
        border: `1px solid ${C.border}`,
        overflow: 'hidden',
        boxShadow: C.shadow,
      }}>
        {children}
      </div>
    </div>
  );
}

export function SubPageHeader({ title, subtitle, onBack }) {
  return (
    <div style={{
      padding: '0 20px 16px',
      paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)',
      flexShrink: 0,
    }}>
      <button
        onClick={onBack}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          background: C.tealSoft, border: `1px solid ${C.border}`,
          borderRadius: 999, padding: '7px 14px 7px 10px',
          cursor: 'pointer', fontFamily: C.font,
          fontSize: 14, fontWeight: 500, color: C.teal,
          marginBottom: 18, WebkitTapHighlightColor: 'transparent',
        }}
      >
        <BackIcon /> Zurück
      </button>
      <div style={{ fontSize: 24, fontWeight: 800, color: C.text, letterSpacing: -0.7, lineHeight: 1.1 }}>
        {title}
      </div>
      {subtitle && (
        <div style={{ fontSize: 13, color: C.textMuted, marginTop: 4 }}>{subtitle}</div>
      )}
    </div>
  );
}

export function LabeledInput({ label, value, onChange, placeholder, readOnly, onFocus, onBlur }) {
  return (
    <div>
      <div style={{
        fontSize: 10, fontWeight: 700, letterSpacing: '0.12em',
        textTransform: 'uppercase', color: C.textDim, marginBottom: 6,
        fontFamily: C.font,
      }}>{label}</div>
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        style={{
          width: '100%', padding: '12px 14px', boxSizing: 'border-box',
          border: `1.5px solid ${C.border}`, borderRadius: 12,
          background: readOnly ? C.tealSoft : C.surfaceAlt,
          fontFamily: C.font, fontSize: 14, color: C.text,
          outline: 'none', transition: 'border-color 0.15s',
        }}
        onFocus={e => {
          if (!readOnly) e.target.style.borderColor = 'rgba(255,188,0,0.6)';
          onFocus && onFocus(e);
        }}
        onBlur={e => {
          e.target.style.borderColor = C.border;
          onBlur && onBlur(e);
        }}
      />
    </div>
  );
}
